module.exports = {
  login: 'Einloggen um Gutscheine anzuzeigen',
  vouchersTitle: 'Gutscheine',
  bookNow: 'Neue Buchung mit Gutschein',
  voucherLookup:'Gutschein prüfen',
  voucherRefunded: 'Rückerstattet',
  voucherExpired: 'Abgelaufen',
  emailAddress: 'Email Adresse',
  ref: 'Buchungs-/Gutschein Nummer',
  lookUp: 'suchen',
  noVoucher: 'Es wurde kein aktiver Gutschein gefunden, bitte die Angaben prüfen und erneut versuchen.',
  requestRefund: 'Eine Rückerstattung beantragen',
  headings: {
    voucher: 'Gutschein',
    booking: 'Buchung',
    total: 'Gesamtbetrag',
    redeemed: 'Eingelöst',
    balance: 'Betrag',
    created: 'Erstellt am',
    expiry: 'Ablaufdatum',
    nonFlex: 'Flexibel?*'
  },
  types: {
    active: 'Aktive',
    redeemed: 'Eingelöst',
    refunded: 'Rückerstattet',
    expired: 'Abgelaufen'
  },
  vouchersFor: 'Gutscheine für',
  noVouchersFound: 'Leider wurden keine Gutscheine gefunden'
}



// WEBPACK FOOTER //
// ./shared/config/components/vouchers/it/index.js